import {
  FETCH_PRODUCER_DATA_PRODUCTS,
  APPEND_PRODUCER_DATA_PRODUCTS,
  FETCH_PRODUCER_DATA_PRODUCTS_REQUEST,
  APPEND_PRODUCER_DATA_PRODUCTS_REQUEST,
  SET_PRODUCER_DATA_PRODUCTS_LOADING,
  RESET_PRODUCER_DATA,
} from '../../constants/reducerTypes';

const initialState = {
  myDataProducts: {
    data: null,
    mdploading: true,
    mdperror: null,
    mdpPageNumber: null,
    mdpTotalPages: null,
    mdpTotalItems: null,
  },
  dataProductRequests: {
    data: null,
    dprloading: true,
    dprerror: null,
    dprPageNumber: null,
    dprTotalPages: null,
    dprTotalItems: null,
  },
};

export default function producerDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PRODUCER_DATA_PRODUCTS:
      return {
        ...state,
        myDataProducts: {
          data: action.payload.data,
          mdploading: false,
          mdperror: action.payload.error,
          mdpPageNumber: action.payload.pageNumber,
          mdpTotalPages: action.payload.totalPages,
          mdpTotalItems: action.payload.totalItems,
        },
      };
    case APPEND_PRODUCER_DATA_PRODUCTS:
      return {
        ...state,
        myDataProducts: {
          ...state.myDataProducts,
          data: [...(state.myDataProducts?.data || []), ...(action.payload.data || [])],
          mdploading: false,
          mdperror: action.payload.error,
          mdpPageNumber: action.payload.pageNumber,
          mdpTotalPages: action.payload.totalPages,
          mdpTotalItems: action.payload.totalItems,
        },
      };
    case SET_PRODUCER_DATA_PRODUCTS_LOADING:
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          [action.payload.loader]: true,
        },
      };
    case FETCH_PRODUCER_DATA_PRODUCTS_REQUEST:
      return {
        ...state,
        dataProductRequests: {
          data: action.payload.data,
          dprloading: false,
          dprerror: action.payload.error,
          dprPageNumber: action.payload.pageNumber,
          dprTotalPages: action.payload.totalPages,
          dprTotalItems: action.payload.totalItems,
        },
      };
    case APPEND_PRODUCER_DATA_PRODUCTS_REQUEST:
      return {
        ...state,
        dataProductRequests: {
          ...state.dataProductRequests,
          data: [...(state.dataProductRequests?.data || []), ...(action.payload.data || [])],
          dprloading: false,
          dprerror: action.payload.error,
          dprPageNumber: action.payload.pageNumber,
          dprTotalPages: action.payload.totalPages,
          dprTotalItems: action.payload.totalItems,
        },
      };
    case RESET_PRODUCER_DATA:
      return initialState;
    default:
      return state;
  }
}
